import {useCallback, useState} from 'react';
import {useBetween} from 'use-between';

const useGlobalScrollHook = () => {
  const [scrollEnabled, setStoredEnabled] = useState(true);

  const enableScroll = useCallback(() => {
    setStoredEnabled(true);
  }, []);

  const disableScroll = useCallback(() => {
    setStoredEnabled(false);
  }, []);

  return {
    scrollEnabled,
    enableScroll,
    disableScroll,
  };
};

export const useGlobalScroll = () => useBetween(useGlobalScrollHook);
